// map.js

function initMap() {
  mapboxgl.accessToken = 'pk.eyJ1IjoiMjl4IiwiYSI6ImNrdm00ajJkMDA3ZmIyc2pwMHdqZDM2aTYifQ.g_WQHa7Aj5QibhgTyrrHzg';

  const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/29x/cmb6e479l00o101qx73ed8j21?optimize=true',
    center: [10.20962, 56.13819],
    minzoom: 2,
    maxzoom: 16,
    pitch: 0,
    bearing: 0,
    fadeDuration: 0,
    renderWorldCopies: false,
    antialias: true,
    attributionControl: false
  });

  // Optional: make it accessible globally
  window.map = map;
}

// Expose function for use in master.js
window.initMap = initMap;
